fx.ns("desktop.common.screens", class SuspendedBook extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;
	}

	create()
	{
		let box = new fx.components.Box();

		box.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:260, height : 260, top : 0, left : "center"});

		let title = new fx.components.Text({text : fx.text("Votre album sera bientôt accessible"), className : "title center"});
		let text = new fx.components.Text({text :fx.text("Il est en cours d'envoi vers nos imprimantes."), className : "text center"});

		box.addChild(title, {width:"100%", top : 280, left : "center"});
		box.addChild(text, {width:"100%", top : 330, left : "center"});

		this.addChild(box, { width : 450, height : 450, top : "center", left : "center"});
	}

	onReady()
	{
		this.addClass("Splash");
		this.delay(this.onQuit, 5000);
	}

	onQuit()
	{
		this.data.event("navigate-exit");
	}

});

	